/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card__list-biliography[_ngcontent-%COMP%]{margin-bottom:2rem}.card__list-biliography[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:24px;font-weight:500;color:#1268a0;vertical-align:middle}.card__list-biliography[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin-bottom:1rem}"];
export { styles as styles };
